var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDisplayAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4133 8.41333L11.56 11L9 5L15 7.56L12.4133 8.41333Z",
    stroke: "#373F41",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 16.2,
    height: 16.2,
    rx: 1.6,
    stroke: "#373F41",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H4C3.44772 3 3 3.44772 3 4V6C3 6.55228 3.44772 7 4 7H7.8",
    stroke: "#373F41",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisplayAds);
export default __webpack_public_path__ + "static/media/IconDisplayAds.41a71030ddd208a08ae85d9944e0f394.svg";
export { ForwardRef as ReactComponent };